import { render, staticRenderFns } from "./ServicesList.vue?vue&type=template&id=493b0ec8"
import script from "./ServicesList.vue?vue&type=script&lang=js"
export * from "./ServicesList.vue?vue&type=script&lang=js"
import style0 from "./ServicesList.vue?vue&type=style&index=0&id=493b0ec8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports